import { Classes, Dialog, FormGroup, Switch } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { PerfilStore } from "../../stores/perfil/PerfilStore";
import LoadingModal from "../loading/LoadingModal";

@observer
export default class FormaPagamento
  extends React.Component<{}, {}>
{
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <h3 className="titleProccess">Escolha a forma de pagamento:</h3>
        <MDBRow>
          <MDBCol md="6">
            <FormGroup
              label="Boleto"
              labelFor="bank_slip"
            >
              <Switch
                onChange={(e: any) => PerfilStore.obs.metodo_pagamento = e.target.checked ? "bank_slip" : ""}
                checked={PerfilStore.obs.metodo_pagamento.includes("bank_slip")}
              />
            </FormGroup>
          </MDBCol>

          <MDBCol md="6">
            <FormGroup
              label="Cartão de Crédito"
              labelFor="credit_card"
            >
              <Switch
                onChange={(e: any) => PerfilStore.obs.metodo_pagamento = e.target.checked ? "credit_card" : ""}
                checked={PerfilStore.obs.metodo_pagamento.includes("credit_card")}
              />
            </FormGroup>
          </MDBCol>
          <MDBCol md="12">

            {PerfilStore.obs.metodo_pagamento.includes("credit_card") &&
              <p>Obs: Se você deseja utilizar o mesmo cartão para pagamentos futuros basta marcar a Checkbox (Usar este cartão de crédito em cobranças futuras) na fatura!</p>
            }

            <MDBBtn
              className="btnDefault"
              onClick={() => PerfilStore.alterPlan()}
            >
              Salvar
            </MDBBtn>
            
          </MDBCol>
        </MDBRow>

        <LoadingModal open={PerfilStore.obs.loading_alterPlano} onClose={() => PerfilStore.obs.loading_alterPlano = false} title={"Atualizando método de pagamento"} />
      </>
    );
  }
}
